const {Component} = require("react");
const PropTypes = require("prop-types");
const Image = require("app/components/mixins/LazyImg");

class Post extends Component {

	static get propTypes() {
		return {
			title: PropTypes.string.isRequired,
			category_name: PropTypes.string.isRequired,
            thumbnail_url: PropTypes.string.isRequired,
			description: PropTypes.string,
			url: PropTypes.string,
		};
	}

	static get defaultProps() {
		return {
			description: "",
			url: "#"
		};
	}

	render() {
		return (
			<div className="search-result post">
				<div className="thumbnail object-fit">
					<a href={this.props.url}>
						<Image src={this.props.thumbnail_url} name={this.props.title} loader={false} afterload={'true'}/>
					</a>
				</div>
				<div className="info">
					<div className="title">
						<a href={this.props.url}>{this.props.title}</a>
					</div>
					<div className="subtitle">
						<span>Blog</span>
						<span>{this.props.categoryName}</span>
					</div>
					<div className="description">{this.props.description}</div>
					<a className="arrow-link" href={this.props.url}></a>
				</div>
			</div>
		);
	}

}

module.exports = Post;